import { useTheme } from "@emotion/react";
import { Button } from "@mui/material";
import { tokens } from "../theme";

/**
 * createForm / formEdit ortak gradient buton stilleri (mor düz renk yerine).
 * @param {'addText'|'addMultipleChoice'|'addTable'|'addImage'|'addRatingScale'|'cancel'|'save'} preset
 */
export default function FormGradientButton({
  preset = "addText",
  children,
  sx = {},
  ...props
}) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const presets = {
    addText: {
      minWidth: 200,
      background: `linear-gradient(135deg, ${colors.blueAccent[600]} 0%, ${colors.blueAccent[400]} 100%)`,
      boxShadow: `0 4px 16px ${colors.blueAccent[600]}40`,
      hoverShadow: `0 6px 20px ${colors.blueAccent[600]}60`,
    },
    addMultipleChoice: {
      minWidth: 200,
      background: `linear-gradient(135deg, ${colors.blueAccent[500]} 0%, ${colors.greenAccent[500]} 100%)`,
      boxShadow: `0 4px 16px ${colors.greenAccent[600]}40`,
      hoverShadow: `0 6px 20px ${colors.greenAccent[600]}60`,
    },
    addTable: {
      minWidth: 200,
      background: `linear-gradient(135deg, ${colors.greenAccent[600]} 0%, ${colors.greenAccent[700]} 100%)`,
      boxShadow: `0 4px 16px ${colors.greenAccent[600]}40`,
      hoverShadow: `0 6px 20px ${colors.greenAccent[600]}60`,
    },
    addImage: {
      minWidth: 220,
      background: `linear-gradient(135deg, ${colors.greenAccent[500]} 0%, ${colors.blueAccent[500]} 100%)`,
      boxShadow: `0 4px 16px ${colors.greenAccent[500]}40`,
      hoverShadow: `0 6px 20px ${colors.greenAccent[500]}60`,
    },
    addRatingScale: {
      minWidth: 220,
      background: `linear-gradient(135deg, ${colors.redAccent[600]} 0%, ${colors.greenAccent[600]} 100%)`,
      boxShadow: `0 4px 16px ${colors.redAccent[600]}40`,
      hoverShadow: `0 6px 20px ${colors.greenAccent[600]}60`,
    },
    cancel: {
      minWidth: 120,
      background: `linear-gradient(135deg, ${colors.redAccent[600]} 0%, ${colors.redAccent[700]} 100%)`,
      boxShadow: `0 4px 16px ${colors.redAccent[600]}40`,
      hoverShadow: `0 6px 20px ${colors.redAccent[500]}60`,
    },
    save: {
      minWidth: 120,
      background: `linear-gradient(135deg, ${colors.greenAccent[500]} 0%, ${colors.greenAccent[600]} 100%)`,
      boxShadow: `0 4px 16px ${colors.greenAccent[500]}40`,
      hoverShadow: `0 6px 20px ${colors.greenAccent[500]}60`,
    },
  };

  const p = presets[preset] || presets.addText;

  return (
    <Button
      variant="contained"
      disableElevation
      sx={{
        borderRadius: 2,
        textTransform: "none",
        fontWeight: 600,
        color: "white",
        background: p.background,
        boxShadow: p.boxShadow,
        minWidth: p.minWidth,
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: p.hoverShadow,
          background: p.background,
        },
        "&:disabled": {
          transform: "none",
          background: colors.grey[700],
          color: colors.grey[400],
          boxShadow: "none",
          opacity: 0.85,
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
}
